
import dayjs from "dayjs";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component
export default class allCcass extends Vue {
  public name: string = "g-allccass";
  headers: views.header[] = [
    {
      title: "序列",
      key: "id",
      align: "left"
    },
    {
      title: "席位ID",
      key: "participantId",
      width: 90
    },
    {
      title: "席位名称",
      key: "participantCN",
      width: 390
    },

    {
      title: "持股总值",
      key: "holdingValue",
      width: 210,
      sortable: true,
      align: "right",
      sortType: "desc"
    },
    {
      title: "最近一日增减持",
      key: "holdingValueChange",
      width: 280,
      align: "right",
      sortable: true,
      sortType: "desc"
    },
    {
      title: "日期",
      key: "tradingDay",
      width: 160,
      align: "right"
    }
  ];
  endDate: string = "";
  loading: boolean = false;
  list: GAPI.participantOverviewItem[] = [];
  get showDay(): string {
    return dayjs(this.endDate).format("YYYY-MM-DD");
  }
  getTodayTimestamps(num?: number | null): number {
    if (!num) {
      return new Date().setHours(0, 0, 0, 0) / 1000;
    }
    return (
      dayjs
        .unix(num)
        .toDate()
        .setHours(0, 0, 0, 0) / 1000
    );
  }
  async getList(date: string): Promise<void> {
    this.loading = true;
    const tmps = dayjs(date).unix();
    const { data } = await this.$api.GetCassBrokersViews({
      time: +tmps
    });
    this.loading = false;
    if (data && Array.isArray(data)) {
      this.list = data;
    } else {
      this.list = [];
    }
  }

  mounted(): void {
    let tmps = this.$route.query.time || this.getTodayTimestamps();
    this.endDate = dayjs
      .unix(+tmps)
      .subtract(1, "day")
      .format("YYYY-MM-DD");
    this.getList(this.endDate);
  }
}
